import { Controller } from "@hotwired/stimulus";

// Identifier: "skylight-carousel" (derived from filename)
export default class extends Controller {
  static targets = ["image", "thumb"];
  static values = { images: Array, index: Number, interval: Number };

  connect() {
    this._boundKey = this._onKey.bind(this);
    document.addEventListener("keydown", this._boundKey);

    if (this.intervalValue > 0) {
      this._timer = setInterval(() => this.next(), this.intervalValue);
    }
    this._bindSwipe();
    this._render();
  }

  disconnect() {
    document.removeEventListener("keydown", this._boundKey);
    if (this._timer) clearInterval(this._timer);
    this._unbindSwipe();
  }

  prev() {
    const n = this.imagesValue.length;
    this.indexValue = (this.indexValue - 1 + n) % n;
    this._render(true);
  }

  next() {
    const n = this.imagesValue.length;
    this.indexValue = (this.indexValue + 1) % n;
    this._render(true);
  }

  // data-skylight-carousel-index-param
  go(e) {
    const i = Number(e.params.index);
    if (!Number.isNaN(i)) {
      this.indexValue = i;
      this._render(true);
    }
  }

  _render(focusThumb = false) {
    const src = this.imagesValue[this.indexValue];
    if (src) this.imageTarget.src = src;

    this.thumbTargets.forEach((btn, i) => {
      const active = i === this.indexValue;
      btn.setAttribute("aria-selected", String(active));
      btn.classList.toggle("border-blue-600", active);
      btn.classList.toggle("border-transparent", !active);
      btn.classList.toggle("opacity-100", active);
      btn.classList.toggle("opacity-60", !active);
      if (focusThumb && active) btn.focus({ preventScroll: true });
    });
  }

  _onKey(e) {
    if (e.key === "ArrowLeft") this.prev();
    if (e.key === "ArrowRight") this.next();
  }

  _bindSwipe() {
    this._onPointerDown = (e) => {
      this._startX = e.clientX ?? (e.touches && e.touches[0].clientX);
      this._swiping = true;
    };
    this._onPointerUp = (e) => {
      if (!this._swiping) return;
      const endX = e.clientX ?? (e.changedTouches && e.changedTouches[0].clientX);
      const dx = endX - this._startX;
      const threshold = 40;
      if (dx > threshold) this.prev();
      if (dx < -threshold) this.next();
      this._swiping = false;
    };

    const el = this.imageTarget;
    el.addEventListener("pointerdown", this._onPointerDown, { passive: true });
    el.addEventListener("pointerup", this._onPointerUp, { passive: true });
    el.addEventListener("touchstart", this._onPointerDown, { passive: true });
    el.addEventListener("touchend", this._onPointerUp, { passive: true });
  }

  _unbindSwipe() {
    const el = this.imageTarget;
    if (!el) return;
    el.removeEventListener("pointerdown", this._onPointerDown);
    el.removeEventListener("pointerup", this._onPointerUp);
    el.removeEventListener("touchstart", this._onPointerDown);
    el.removeEventListener("touchend", this._onPointerUp);
  }
}
